<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入产品</span>
    </template>
    <template #content>
      <gj-upload
          template-url="/supply/assemble/downloadTemplate"
          container-type="assembleOrderProduct"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 12px;">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls的文件',
            '模板中的表头不可更改，不能删除',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "@/minxins";

  export default {
    name: "app-import-product-modal",
    mixins: [modalMixIn, uploadMixin],
    props: {
      warehouseId: {
        required: true,
      },
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        this.$gjRequest.post(`/supply/assemble/importAssembleProduct`, {
          attachmentId: attId,
          warehouseId: this.warehouseId
        })
          .then((res) => {
            this.$gjImportHandle(res, uploadCb)
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>
